export function LocSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="20"
      fill="none"
      viewBox="0 0 22 20"
    >
      <path
        fill="#299D93"
        d="M18.998 7.042c-.922-3.85-4.46-5.584-7.567-5.584h-.01c-3.098 0-6.645 1.725-7.566 5.575-1.027 4.3 1.747 7.942 4.257 10.234a4.91 4.91 0 003.319 1.275 4.872 4.872 0 003.31-1.275c2.51-2.292 5.284-5.925 4.257-10.225zm-7.567 4.175c-1.528 0-2.766-1.175-2.766-2.625s1.238-2.625 2.766-2.625c1.527 0 2.765 1.175 2.765 2.625s-1.238 2.625-2.765 2.625z"
      ></path>
    </svg>
  );
}

export function SmallSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="6"
      fill="none"
      viewBox="0 0 6 6"
    >
      <ellipse cx="2.634" cy="3" fill="#299D93" rx="2.634" ry="2.5"></ellipse>
    </svg>
  );
}